module.exports = __webpack_public_path__ + "img/icon-song.c144824a.png";